import { makeStyles } from "@material-ui/core/styles";

const theme = (props) => {
  const styles = makeStyles(theme => ({
    container: {
      width: 'calc(100% - 20px)',
      marginBottom: 20,
      '& .pointer': {
        cursor: 'pointer'
      }
    },
    table: {
      minWidth: 650,
      width: 'calc(100% - 50px)',
      margin: '15px 25px',
      '& .MuiTableCell-head': {
        color: '#989898',
        fontSize: 13,
        fontWeight: 400,
        borderBottomWidth: 2,
      },
      '& .MuiTableCell-body': {
        color: '#989898',
        fontSize: '13px !important',
        fontWeight: 200,
        '& svg': {
          fontSize: '13px !important',
          fill: '#989898'
        }
      },
    },
    importListItem: {
      color: `${props.color2} !important`,
      fontWeight: '400 !important',
      opacity: '0.8',
    },
    tableTitle: {
      color: '#989898',
      fontWeight: 400,
      padding: 10,
      fontSize: 20,
      textTransform: 'uppercase',
      '& span': {
        color: `${props.color2} !important`,
      }
    },
    titleContainer: {
      width: '100%',
      paddingTop: 20,
      paddingBottom: 10,
      display: 'inline-flex',
      justifyContent: 'space-between',
    },
    titleDateFilter: {
      display: 'inline-flex',
      alignContent: 'center',
      '& p': {
        display: 'flex',
        alignItems: 'center',
        height: 34,
        margin: 0,
        color: '#989898',
        fontSize: 13,
      },
    },
    responsiveContainer: {
      padding: 15,
      width: 'calc(100% - 20px)',
      color: '#989898',
      fontSize: 13,
      borderBottom: '1px solid #989898',
      '& .label': { fontWeight: 400, marginBottom: 10 },
      '& .text': { fontWeight: 200, marginBottom: 10 },
    },

    '@media (max-width: 600px)': {
      container: {
        width: '100%',
        marginTop: 0,
      },
      table: {
        maxWidth: '100%',
        margin: 0,
      },
      responsiveContainer: {
        width: '100%',
        boxSizing: 'border-box',
        padding: 10,
        marginBottom: 10,
        border: '1px solid rgba(17,24,39,0.10)',
        borderRadius: 10,
        background: '#fff',
      },

      leftCol: { display: 'flex', flexDirection: 'column', paddingRight: 8 },
      midCol: { display: 'flex', flexDirection: 'column', paddingRight: 8 },
      rightCol: { display: 'flex', alignItems: 'center', justifyContent: 'flex-end' },

      kvRow: { display: 'flex', flexDirection: 'column', marginBottom: 5 },
      kvLabel: { color: 'var(--text-muted)', fontSize: '0.75rem', fontWeight: 500 },
      kvValue: { color: 'var(--text-strong)', fontSize: '0.9rem', fontWeight: 500, wordBreak: 'break-word' },

      pdfIcon: {
        width: 40,
        height: 40,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 8,
        marginRight: 15,
        border: '1px solid rgba(17,24,39,0.25)',
        background: 'rgba(17,24,39,0.08)',
        cursor: 'pointer',
        '& img': { width: 18, height: 18, filter: 'brightness(0.45) contrast(1.3)' },
      },

    },
  }));
  return styles();
}
export default theme;

